import { axiosAuth } from './axiosInstances'
//agregar una funcion por cada endpoint necesario, asegurarse de usar el async-await, ya que son peticiones a la api
// KHAN-123: moment esta en modo mantenimiento; dayjs cubre `.format()` con
// el mismo formato ISO-8601 con offset por defecto.
const dayjs = require('dayjs')

// KHAN-226: api/books/{new-book,list,list-published,list-notPublished,
// list-private,search/<title>,book-by-id/<id>,full-book/<id>,change,
// modify-state-private,modify-state-publish} -> recurso REST api/books/:
//   POST   books/                       (antes new-book/)
//   GET    books/                       (antes list/, paginado)
//   GET    books/?state=published       (antes list-published/)
//   GET    books/?state=unpublished     (antes list-notPublished/)
//   GET    books/?state=private         (antes list-private/)
//   GET    books/?title=&match=exact    (antes search/<title>)
//   GET    books/{id}/                  (antes book-by-id/<id>)
//   GET    books/{id}/?expand=relations (antes full-book/<id>)
//   PATCH  books/{id}/                  (antes PUT change/, por titulo)
//   POST   books/{id}/publish/          (antes PUT modify-state-publish/)
//   POST   books/{id}/unpublish/        (antes PUT modify-state-private/)
// publish/unpublish/PATCH ahora reciben el id del libro, no el titulo.

export async function new_book(
  title,
  category,
  portrait,
  createdby,
  updatedby,
  state,
  sharedbook,
  lastupdateby,
  description
) {
  return axiosAuth().post('books/', {
    title: title,
    category: category,
    portrait: portrait,
    createdby: createdby,
    createdat: dayjs().format(),
    updatedby: updatedby,
    lastupdateat: dayjs().format(),
    state: state,
    sharedbook: sharedbook,
    lastupdateby: lastupdateby,
    description: description,
  })
}

// Busqueda por titulo EXACTO: devuelve un unico libro (o 403/404/409).
export async function bookSearch(title) {
  return axiosAuth().get('books/', { params: { title: title, match: 'exact' } })
}

// PATCH parcial: solo se envian los campos recibidos en `fields`
// ({ title, portrait, category, description, state }).
export async function bookChange(idBook, fields) {
  return axiosAuth().patch(`books/${idBook}/`, fields)
}

export async function listed() {
  return axiosAuth().get('books/')
}

export async function listed_PublishedBooks() {
  return axiosAuth().get('books/', { params: { state: 'published' } })
}

export async function listed_NotPublishedBooks() {
  return axiosAuth().get('books/', { params: { state: 'unpublished' } })
}

export async function listed_PrivateBooks() {
  return axiosAuth().get('books/', { params: { state: 'private' } })
}

export async function modifyStateToPrivate(idBook) {
  return axiosAuth().post(`books/${idBook}/unpublish/`)
}

export async function modifyStateToPublish(idBook) {
  return axiosAuth().post(`books/${idBook}/publish/`)
}

export async function bookSearchById(idBook) {
  return axiosAuth().get(`books/${idBook}/`)
}

export function fullBook(idBook) {
  return axiosAuth().get(`books/${idBook}/`, { params: { expand: 'relations' } })

  // Datos quemados
  // return fullBookJson
}
